import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormESYSurvey } from "../Models/Forms/IFormESYSurvey";

@Injectable()
export class FormESYSurveyService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormESYSurvey(id: number) {
    return this._http.get(this._baseUrl + "api/FormESYSurvey/" + id)
      .map((response: IFormESYSurvey) => response as IFormESYSurvey)
      .catch(this.errorHandler);
  }

  insertUpdateFormESYSurvey(formESYSurveyDetails: IFormESYSurvey) {
    return this._http.post(this._baseUrl + 'api/FormESYSurvey', formESYSurveyDetails)
      .map((response: IFormESYSurvey) => response as IFormESYSurvey)
      .catch(this.errorHandler);
  }

  deleteESYSurvey(id) {
    return this._http.delete(this._baseUrl + "api/FormESYSurvey" + id)
      .map((response: IFormESYSurvey) => response as IFormESYSurvey)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}








//@Injectable()
//export class FormSignatureComponent implements OnInit {

//  myAppUrl: string = "";


//  constructor(
//    private _formESYSurveyService: FormESYSurveyService,
//    private formBuilder: FormBuilder,
//    @Inject('BASE_URL') baseUrl: string) {
//    this._baseUrl = baseUrl;
//    this.buildForm();
//  }


//  ngOnInit(): void {
//    this.LoadFormESYFormDetails();
//  }

  //LoadFormESYFormDetails(): void {
  //  //TODO: need to replace URL and  Id value from Service Call
  //  this._formESYSurveyService.get(this._baseUrl + "api/ESYSurvey/50").subscribe((res: IFormESYSurvey) => {
  //    this.formManifestationDeterminationDetailsFromDB = res,
  //      this.formESYSurveyDetailsFromDB.criticalLifeSkillsBreakthrough = res.criticalLifeSkillsBreakthrough;
  //    this.formFormESYSurveyDetailsFromDB.esyServicesDescription = res.esyServicesDescription;
  //    this.formFormESYSurveyDetailsFromDB.esyServicesRequiredForFAPE = res.esyServicesRequiredForFAPE;
  //    this.formFormESYSurveyDetailsFromDB.insertedBy = res.insertedBy;
  //    this.formFormESYSurveyDetailsFromDB.insertedOn = res.insertedOn;
  //    this.formFormESYSurveyDetailsFromDB.interferingBehavior = res.interferingBehavior;
  //    this.formFormESYSurveyDetailsFromDB.isDeleted = res.isDeleted;
  //    this.formFormESYSurveyDetailsFromDB.natureSeverityOfDisability = res.natureSeverityOfDisability;
  //    this.formFormESYSurveyDetailsFromDB.progressTowardCriticalLifeSkills = res.progressTowardCriticalLifeSkills;
  //    this.formFormESYSurveyDetailsFromDB.regressionAndRecoupment = res.regressionAndRecoupment;
  //    this.formFormESYSurveyDetailsFromDB.schoolName = res.schoolName;
  //    this.formFormESYSurveyDetailsFromDB.specialCircumstances = res.specialCircumstances;
  //    this.formFormESYSurveyDetailsFromDB.sSID = res.sSID;
  //    this.formFormESYSurveyDetailsFromDB.studentName = res.studentName;
  //    this.formFormESYSurveyDetailsFromDB.surveyDate = res.surveyDate;
  //    this.formFormESYSurveyDetailsFromDB.updatedBy = res.updatedBy;
  //    this.formFormESYSurveyDetailsFromDB.updatedOn = res.updatedOn;
  //  },
  //    err => console.error(err)
  //  );
  //}

  //get(url: string): Observable < IFormESYSurvey > {
  //  return this._http.get<IFormESYSurvey>(url).map((response: IFormESYSurvey) => response as IFormESYSurvey)

  //        .catch(this.handleError);
  //    }
  //}
  //saveESYSurvey(formESYSurveytDetails) {

  //    return this._http.post(this.myAppUrl + 'api/ESYSurvey/Create', formESYSurveytDetails)
  //      .subscribe(response => console.log(response));


  //    //return this._http.post(this.myAppUrl + 'api/ESYSurvey/Create', formESYSurveytDetails)
  //    //  .map((response: Response) => response.json())
  //    //  .catch(this.handleError);

  //    handleError(error) {
  //      let errorMessage = '';
  //      if (error.error instanceof ErrorEvent) {
  //        // client-side error
  //        errorMessage = `Error: ${error.error.message}`;
  //      } else {
  //        // server-side error
  //        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  //      }
  //      window.alert(errorMessage);
  //      return throwError(errorMessage);

  //    }
  //  }

//}
